import _parseFloat from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/parse-float";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";
import getHoroscopeFates from "@/utils/getHoroscopeFates";

var FateClass =
/*#__PURE__*/
function (_Vue) {
  _inherits(FateClass, _Vue);

  function FateClass() {
    var _this;

    _classCallCheck(this, FateClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FateClass).apply(this, arguments));
    _this.clickIndex = -1;
    return _this;
  }

  _createClass(FateClass, [{
    key: "clickItem",
    value: function clickItem(itemData, idx) {
      this.clickIndex = idx;
      this.updataLoadingStatus(true);
      itemData.clickFunction ? itemData.clickFunction() : void 0;
      getHoroscopeFates.getFates(true);
    }
  }, {
    key: "watchIndex",
    value: function watchIndex(val) {
      this.clickIndex = val;
    } // 计算比例的最小公约数

  }, {
    key: "baseData",
    get: function get() {
      var clientHeight = document.body.clientHeight;
      var barHeight = window.StatusBar.actualHeight;
      var strBodyFontSize = document.documentElement.style.fontSize;

      var bodyFontSize = _parseFloat(strBodyFontSize);

      var contentHeight = (80 * 4 + 78 + 18 * 4 + 16) / 16 * bodyFontSize;
      return (clientHeight - 2 * barHeight - 44 - contentHeight) / 122;
    }
  }]);

  return FateClass;
}(Vue);

tslib_1.__decorate([Prop({
  default: []
})], FateClass.prototype, "dataList", void 0);

tslib_1.__decorate([Prop({
  default: true
})], FateClass.prototype, "sectionWrape", void 0);

tslib_1.__decorate([Prop()], FateClass.prototype, "index", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_LOADING_STATUS)], FateClass.prototype, "updataLoadingStatus", void 0);

tslib_1.__decorate([Watch('index')], FateClass.prototype, "watchIndex", null);

FateClass = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], FateClass);
export default FateClass;